import {NgModule, Injector} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {IrbCommonModule} from "@irb-common/irb-common.module";
import {EditorPortfolioComponent} from "./editor-portfolio/editor-portfolio.component";
import {EditorSidebarComponent} from "./editor-sidebar/editor-sidebar.component";
import {SidebarModule} from "primeng/sidebar";
import {EditorAccountComponent} from "./editor-account/editor-account.component";
import {EditorSidebarBannerComponent} from "./editor-sidebar-banner/editor-sidebar-banner.component";
import {ComAccountsComponent} from "./editor-portfolio/com-accounts/com-accounts.component";
import {ComRestrictionsComponent} from "./editor-portfolio/com-restrictions/com-restrictions.component";
import {ServiceLocator} from "@irb-common/services/locator.service";
import {IrbEditorsService} from "@irb/irb-editors/irb-editors.service";
import {UtilityService} from "@irb-common/services/utility.service";
import {ValidationService} from "@irb-common/services/validation.service";
import {AppService} from "@irb/app.service";
import {PageService} from "@irb-common/services/page.service";
import {ComPortfolioNotesComponent} from "./editor-portfolio/com-portfolio-notes/com-portfolio-notes.component";
import {ComAssignmentsComponent} from "./editor-portfolio/com-assignments/com-assignments.component";
import {ComAssignPortfolioComponent} from "./editor-account/com-assign-portfolio/com-assign-portfolio.component";
import {ComTreatmentOptionsComponent} from "./editor-account/com-treatment-options/com-treatment-options.component";
import {ComCashNeedsComponent} from "./editor-account/com-cash-needs/com-cash-needs.component";
import {ComExternalAccountsComponent} from "./editor-account/com-external-accounts/com-external-accounts.component";
import {ComAccountHistoryComponent} from "./editor-account/com-account-history/com-account-history.component";
import {EditorModelComponent} from "./editor-model/editor-model.component";
import {EditorMultiplePortfoliosComponent} from "./editor-multiple-portfolios/editor-multiple-portfolios.component";
import {EditorBlendedModelComponent} from "./editor-blended-model/editor-blended-model.component";
import {EditorCoveredcallRebalanceComponent} from "./editor-coveredcall-rebalance/editor-coveredcall-rebalance.component";
import {EditorFullRebalanceComponent} from "./editor-full-rebalance/editor-full-rebalance.component";
import {RebalanceSchedulerComponent} from "./rebalance/rebalance-scheduler/rebalance-scheduler.component";
import {RebalanceGeneralInfoComponent} from "./rebalance/rebalance-general-info/rebalance-general-info.component";
import {CoveredcallRebalSettingsComponent} from "./editor-coveredcall-rebalance/coveredcall-rebal-settings/coveredcall-rebal-settings.component";
import {SellCoveredcallSettingsComponent} from "./editor-coveredcall-rebalance/coveredcall-rebal-settings/sell-coveredcall-settings/sell-coveredcall-settings.component";
import {BuyToCoverSettingsComponent} from "./editor-coveredcall-rebalance/coveredcall-rebal-settings/buy-to-cover-settings/buy-to-cover-settings.component";
import {PurchaseUnderlyingSettingsComponent} from "./editor-coveredcall-rebalance/coveredcall-rebal-settings/purchase-underlying-settings/purchase-underlying-settings.component";
import {RollCoveredcallSettingsComponent} from "./editor-coveredcall-rebalance/coveredcall-rebal-settings/roll-coveredcall-settings/roll-coveredcall-settings.component";
import {EditorMultipleAccountsComponent} from "./editor-multiple-accounts/editor-multiple-accounts.component";
import {EditorPortfolioResultComponent} from "./editor-portfolio-result/editor-portfolio-result.component";
import {ComPrSummaryComponent} from "./editor-portfolio-result/com-pr-summary/com-pr-summary.component";
import {ComPrCashValuesComponent} from "./editor-portfolio-result/com-pr-cash-values/com-pr-cash-values.component";
import {ComPrOrdersComponent} from "./editor-portfolio-result/com-pr-orders/com-pr-orders.component";
import {ComPrAllocationsComponent} from "./editor-portfolio-result/com-pr-allocations/com-pr-allocations.component";
import {ComPrAllocationChartComponent} from "./editor-portfolio-result/com-pr-allocation-chart/com-pr-allocation-chart.component";
import {ComPrActionPanelComponent} from "./editor-portfolio-result/com-pr-action-panel/com-pr-action-panel.component";
import {ComPrInfoBannerComponent} from "./editor-portfolio-result/com-pr-info-banner/com-pr-info-banner.component";
import {DaysToExpirationCellEditor} from "./editor-coveredcall-rebalance/coveredcall-rebal-settings/cc-grid-cell-editors/days-to-expiration-editor.component";
import {SecurityAllocationsComponent} from "./editor-model/security-allocations/security-allocations.component";
import {SecurityModelHistoryComponent} from "./security-model-history/security-model-history.component";
import {SecurityAllocationsChartComponent} from "./editor-model/security-allocations-chart/security-allocations-chart.component";
import {LegacyAllocationsChartComponent} from "./editor-model/legacy-allocations-chart/legacy-allocations-chart.component";
import {MmcAllocationsChartComponent} from "./editor-mmc-model/mmc-allocations-chart/mmc-allocations-chart.component";
import {RebalanceIncludedPortfolioComponent} from "./rebalance/rebalance-included-portfolio/rebalance-included-portfolio.component";
import {ImportExtraCashSettingsDialogComponent} from "./rebalance/rebalance-included-portfolio/import-extra-cash-settings-dialog/import-extra-cash-settings-dialog.component";
import {LossPrioritySettingsDialogComponent} from "./rebalance/rebalance-included-portfolio/loss-priority-settings-dialog/loss-priority-settings-dialog.component";
import {EditorAdjustSecuritiesRebalanceComponent} from "./editor-adjust-securities-rebalance/editor-adjust-securities-rebalance.component";
import {lightningIconCellComponent} from "./rebalance/rebalance-included-portfolio/delete-conditional.cell.component";
import {EditorHarvestTaxLossRebalanceComponent} from "./editor-harvest-tax-loss-rebalance/editor-harvest-tax-loss-rebalance.component";
import {ComHarvestTaxLossRebalanceSettingComponent} from "./editor-harvest-tax-loss-rebalance/harvest-tax-loss-rebalance-setting/harvest-tax-loss-rebalance-setting.component";
import {EditorGenerateCashComponent} from "./editor-generate-cash-rebalance/editor-generate-cash-rebalance.component";
import {EditorGenerateInvestCashComponent} from "./editor-generate-invest-cash-rebalance/editor-generate-invest-cash-rebalance.component";
import {GenerateInvestCashRebalanceSettingsComponent} from "./editor-generate-invest-cash-rebalance/generate-invest-cash-rebalance-settings/generate-invest-cash-rebalance-settings.component";
import {EditorInvertCashComponent} from "./editor-invest-cash-rebalance/editor-invest-cash-rebalance.component";
import {EditorManualAdjustmentRebalanceComponent} from "./manual-adjustment-rebalance/manual-adjustment-rebalance.component";
import {BlendedModelsAllocationComponent} from './editor-blended-model/blended-models-allocation/blended-models-allocation.component';
import {BlendedSecurityAllocationComponent} from './editor-blended-model/blended-security-allocation/blended-security-allocation.component';
import {customCheckboxCellRenderer} from "./rebalance/rebalance-included-portfolio/customCheckBoxCellRenderer.component";
import {EditorReplaceSecuritiesRebalanceComponent} from "./editor-replace-securities-rebalance/editor-replace-securities-rebalance.component";
import {ReplaceSecuritiesRebalSettingsComponent} from "./editor-replace-securities-rebalance/replace-securities-rebal-settings/replace-securities-rebal-settings.component";
import {validationPercentCellEditorComponent} from "./editor-harvest-tax-loss-rebalance/validationPercentCellEditor.component";
import {OptionToOpenCellRenderer} from "./editor-coveredcall-rebalance/coveredcall-rebal-settings/roll-coveredcall-settings/option-to-open-cell-renderer.compoent";
import {EditorSecurityComponent} from './editor-security/editor-security.component';
import {SecurityAssetCategoryComponent} from './editor-security/security-asset-category/security-asset-category.component';
import {EditorMultipleSecurityComponent} from './edit-multiple-security/edit-multiple-security.component';
import {CoverCallToRollCellEditor} from "./editor-coveredcall-rebalance/coveredcall-rebal-settings/cc-grid-cell-editors/cover-call-to-roll.cell.editor";
import {OptionToBuyBackCellEditor} from "./editor-coveredcall-rebalance/coveredcall-rebal-settings/cc-grid-cell-editors/option-to-buy-back.cell.editor";
import {UnderlyingToPurchaseCellEditor} from "./editor-coveredcall-rebalance/coveredcall-rebal-settings/cc-grid-cell-editors/underlying-to-purchase.cell.editor";
import {UnderlyingToTrimCellEditor} from "./editor-coveredcall-rebalance/coveredcall-rebal-settings/cc-grid-cell-editors/underlying-to-trim.cell.editor";
import {UnderlyingToCoverCellEditor} from "./editor-coveredcall-rebalance/coveredcall-rebal-settings/cc-grid-cell-editors/underlying-to-cover.cell.editor";
import {OptionToSellCellRenderer} from "./editor-coveredcall-rebalance/coveredcall-rebal-settings/purchase-underlying-settings/option-to-sell-cell-renderer.compoent";
import {OptionChainsDialog} from "./editor-coveredcall-rebalance/option-chains-dialog/option-chains-dialog.component";
import {TradingMinimumsComponent} from './editor-security/trading-minimums/trading-minimums.component';
import {OptionToCloseRollCellEditor} from "./editor-coveredcall-rebalance/coveredcall-rebal-settings/roll-coveredcall-settings/option-to-close-cell/option-to-close-roll-cell-editor.component";
import {AdjustSecuritiesRebalSettingsComponent} from "@irb/irb-editors/editor-adjust-securities-rebalance/adjust-securities-rebal-settings/adjust-securities-rebal-settings.component";
import {IrbOptionChainsModule} from "@irb/irb-option-chains/irb-option-chains.module";
import {ComponentSecuritiesComponent} from './editor-security/component-securities/component-securities.component';
import {BlendedSecurityAllocationGroupcellComponent} from '@irb/irb-editors/editor-blended-model/blended-security-allocation/blended-security-allocation-groupcell.component';
import {SecurityPenaltybarComponent} from './editor-security/security-penaltybar/security-penaltybar.component';
import {ExternalShareHoldingComponent} from './editor-security/external-share-holding/external-share-holding.component';
import {RebalanceBandsComponent} from './editor-security/rebalance-bands/rebalance-bands.component';
import {SecurityRestrictionsComponent} from './editor-security/security-restrictions/security-restrictions.component';
import {SecurityEquivalentsAlternativesComponent} from './editor-security/security-equivalents-alternatives/security-equivalents-alternatives.component';
import {ComEsSecurityEquivalentsComponent} from './editor-security/security-equivalents-alternatives/com-es-security-equivalents/com-es-security-equivalents.component';
import {ComEsSecurityAlternativesComponent} from './editor-security/security-equivalents-alternatives/com-es-security-alternatives/com-es-security-alternatives.component';
import {altIfHeldCheckboxCellRenderer} from "@irb/irb-editors/editor-security/renderers/altIfHeldCheckBoxCellRenderer.component";
import {InverseAccountTypeDialogComponent} from './editor-security/inverse-account-type-dialog/inverse-account-type-dialog.component';
import {ComponentSecuritiesDeleteCellComponent} from '@irb/irb-editors/editor-security/component-securities/component-securities-delete-cell.component';
import {ComponentSecuritiesDeleteAllComponent} from '@irb/irb-editors/editor-security/component-securities/component-securities-delete-all.component';
import {OptionToCloseCellEditor} from "./editor-coveredcall-rebalance/coveredcall-rebal-settings/buy-to-cover-settings/option-to-close-cell/option-to-close-cell-editor.component";
import {OptionToCloseCellRenderer} from "./editor-coveredcall-rebalance/coveredcall-rebal-settings/buy-to-cover-settings/option-to-close-cell/option-to-close-cell-renderer.component";
import {OptionToCloseRollCellRenderer} from "./editor-coveredcall-rebalance/coveredcall-rebal-settings/roll-coveredcall-settings/option-to-close-cell/option-to-close-roll-cell-renderer.component";
import {EditTradingInstructionsComponent} from './edit-trading-instructions/edit-trading-instructions.component';
import {ReinvestmentTradeComponent} from './edit-trading-instructions/reinvestment-trade/reinvestment-trade.component';
import {TradeInstructionsComponent} from './edit-trading-instructions/trade-instructions/trade-instructions.component';
import {OrderHeaderComponent} from './edit-trading-instructions/order-header/order-header.component';
import {MatSortModule} from '@angular/material/sort';
import {CdkTableModule} from '@angular/cdk/table';
import {SelectMultiplePortfoliosDialogComponent} from "./rebalance/rebalance-included-portfolio/select-multiple-portfolios-dialog/select-multiple-portfolios-dialog.component";
import {HouseholdLocationPreferencesComponent} from '@irb/irb-editors/editor-security/household-location-preferences/household-location-preferences.component';
import {SliderModule} from 'primeng/slider';
import {TradeDetailsComponent} from './edit-trading-instructions/trade-details/trade-details.component';
import {TradeDetailsSymbolRendererComponent} from "@irb/irb-editors/edit-trading-instructions/trade-details/trade-details-symbol.renderer.component";
import {ReplaceWithRendererEditorComponent} from '@irb/irb-editors/editor-replace-securities-rebalance/replace-with-renderer-editor.component';
import {ReplaceWithRendererComponent} from '@irb/irb-editors/editor-replace-securities-rebalance/replace-with-renderer.component';
import {EditorBuyMultipleReplacementComponent} from './editor-buy-multiple-replacement/editor-buy-multiple-replacement.component';
import {ComPrActionButtonsComponent} from './editor-portfolio-result/com-pr-action-buttons/com-pr-action-buttons.component';
import {EditorMmcModelComponent} from './editor-mmc-model/editor-mmc-model.component';
import {MmcOverviewModelComponent} from './editor-mmc-model/mmc-overview-model/mmc-overview-model.component';
import {MmcSecuritiesModelComponent} from './editor-mmc-model/mmc-securities-model/mmc-securities-model.component';
import {MmcImportModelTargetComponent} from './editor-mmc-model/mmc-import-model-target/mmc-import-model-target.component';
import {MmcPerformanceModelComponent} from './editor-mmc-model/mmc-performance-model/mmc-performance-model.component';
import {MmcBackgroundCostModelComponent} from './editor-mmc-model/mmc-background-cost-model/mmc-background-cost-model.component';
import { ImportLossPrioritySettingsDialogComponent } from "./rebalance/rebalance-included-portfolio/import-loss-priority-settings-dialog/import-loss-priority-settings-dialog.component";
import { ImportLossPrioritySettingsErrorsDialogComponent } from './rebalance/rebalance-included-portfolio/import-loss-priority-settings-errors-dialog/import-loss-priority-settings-errors-dialog.component';
import { MmcModelHistoryComponent } from './editor-mmc-model/mmc-model-history/mmc-model-history.component';
import { MmcMarketingDocumentsDialogComponent } from './editor-mmc-model/mmc-marketing-documents-dialog/mmc-marketing-documents-dialog.component';
import {EditorMmcAdvisorModelComponent} from './editor-mmc-model/editor-mmc-advisor-model/editor-mmc-advisor-model.component';
import {MmcAdvisorSecurityAllocationsComponent} from '@irb/irb-editors/editor-mmc-model/editor-mmc-advisor-model/mmc-advisor-security-allocations/mmc-advisor-security-allocations.component';
import {SundryAcctAuthDialogComponent} from './editor-mmc-model/editor-mmc-advisor-model/sundry-acct-auth-dialog/sundry-acct-auth-dialog.component';
import {PaidAgreementDialogComponent} from './editor-mmc-model/editor-mmc-advisor-model/paid-agreement-dialog/paid-agreement-dialog.component';
import { UnderlyingTargetCellRendererComponent } from "./editor-coveredcall-rebalance/coveredcall-rebal-settings/purchase-underlying-settings/underlying-target-cell-renderer/underlying-target-cell-renderer.component";
import { MmcOverviewMarketingDocumentsComponent } from './editor-mmc-model/editor-mmc-advisor-model/mmc-overview-marketing-documents/mmc-overview-marketing-documents.component';
import { MoveSecuritiesWarningsDialogComponent } from './editor-security/move-securities-warnings-dialog/move-securities-warnings-dialog.component';
import { MoveSecuritiesGridDataDialogComponent } from './editor-security/move-securities-grid-data-dialog/move-securities-grid-data-dialog.component';
import { MoveSecuritiesUsageReviewDialogComponent } from './editor-security/move-securities-usage-review-dialog/move-securities-usage-review-dialog.component';
import {SecurityComponentsDialogComponent} from './editor-security/security-components-dialog/security-components-dialog.component';
import { ModelUsedInRebalanceDialogComponent } from './editor-portfolio-result/model-used-in-rebalance-dialog/model-used-in-rebalance-dialog.component';
import { ComScheduledRebalancesListComponent } from './editor-portfolio/com-scheduled-rebalances-list/com-scheduled-rebalances-list.component';
import { ComIncludeInScheduledRebalanceDialogComponent } from './editor-portfolio/com-include-in-scheduled-rebalance-dialog/com-include-in-scheduled-rebalance-dialog.component';
import { BlendedModelAllocationGroupcellComponent } from "./editor-blended-model/blended-model-allocation-groupcell.component";
import { ComPrOrdersAccountGroupcellComponent } from './editor-portfolio-result/com-pr-orders/com-pr-orders-account-groupcell/com-pr-orders-account-groupcell.component';
import { ComPortfolioHistoryComponent } from "@irb/irb-editors/editor-portfolio/com-portfolio-history/com-portfolio-history.component";
import { ComAutomatedRebalancingComponent } from "@irb/irb-editors/editor-portfolio/com-automated-rebalancing/com-automated-rebalancing.component";
import { TlhWashSaleAlternativesComponent } from './editor-security/tlh-wash-sale-alternatives/tlh-wash-sale-alternatives.component';
import { RebalanceTypeInfoDialogComponent } from './rebalance/rebalance-type-info-dialog/rebalance-type-info-dialog.component';
import { EditorTlhFullRebalanceComponent } from './editor-tlh-full-rebalance/editor-tlh-full-rebalance.component';
import { TlhRebalanceSettingsComponent } from './editor-harvest-tax-loss-rebalance/tlh-rebalance-settings/tlh-rebalance-settings.component';
import { ComCustomLabelsComponent } from './editor-portfolio/com-custom-labels/com-custom-labels.component';
import { CustomOverviewModelComponent } from '@irb/irb-editors/editor-mmc-model/custom-overview-model/custom-overview-model.component';
import { PortfolioEquivalentsAlternativesComponent } from './editor-portfolio/portfolio-equivalents-alternatives/portfolio-equivalents-alternatives.component';
import { ComAcLevelsComponent } from './editor-security/com-ac-levels/com-ac-levels.component';
import { ComPrHeaderGroupComponent } from '@irb/irb-editors/editor-portfolio-result/com-pr-header-group/com-pr-header-group.component';
import {InvestCashRebalanceSettingsComponent} from "@irb/irb-editors/editor-invest-cash-rebalance/invest-cash-rebalance-settings/invest-cash-rebalance-settings.component";
import { ComGainsComponent } from './editor-portfolio/com-gains/com-gains.component';
import { ComPrAllocationsLegacyComponent } from './editor-portfolio-result/com-pr-allocations-legacy/com-pr-allocations-legacy.component';
import { ComPrAllocationChartLegacyComponent } from './editor-portfolio-result/com-pr-allocation-chart-legacy/com-pr-allocation-chart-legacy.component';
import { ModelAllocationChartGroupComponent } from './editor-model/model-allocation-chart-group/model-allocation-chart-group.component';
import { SecurityHistoryComponent } from './editor-security/security-history/security-history.component';
import { EditorQuickOrderEntryComponent } from './editor-quick-order-entry/editor-quick-order-entry.component';
import { ComPrCashValuesAccountOverlayComponent } from './editor-portfolio-result/com-pr-cash-values/com-pr-cash-values-account-overlay/com-pr-cash-values-account-overlay.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IrbCommonModule,
        SidebarModule,
        IrbOptionChainsModule,
        MatSortModule,
        CdkTableModule,
        SliderModule,
        ComPrAllocationsComponent,
        ComPrAllocationChartComponent,
        ComPrCashValuesAccountOverlayComponent
    ],
    declarations: [
        EditorPortfolioComponent,
        EditorMultiplePortfoliosComponent,
        EditorSidebarComponent,
        EditorAccountComponent,
        EditorSidebarBannerComponent,
        ComAccountsComponent,
        ComRestrictionsComponent,
        ComPortfolioNotesComponent,
        ComAssignmentsComponent,
        ComAssignPortfolioComponent,
        ComTreatmentOptionsComponent,
        ComCashNeedsComponent,
        EditorFullRebalanceComponent,
        EditorManualAdjustmentRebalanceComponent,
        EditorInvertCashComponent,
        EditorGenerateInvestCashComponent,
        EditorGenerateCashComponent,
        EditorAdjustSecuritiesRebalanceComponent,
        RebalanceSchedulerComponent,
        RebalanceGeneralInfoComponent,
        ComExternalAccountsComponent,
        ComAccountHistoryComponent,
        EditorModelComponent,
        EditorBlendedModelComponent,
        EditorCoveredcallRebalanceComponent,
        CoveredcallRebalSettingsComponent,
        SellCoveredcallSettingsComponent,
        BuyToCoverSettingsComponent, DaysToExpirationCellEditor, OptionToCloseCellEditor, OptionToCloseCellRenderer, OptionToCloseRollCellEditor, OptionToCloseRollCellRenderer,
        UnderlyingToCoverCellEditor, UnderlyingToPurchaseCellEditor, UnderlyingToTrimCellEditor, OptionToBuyBackCellEditor, CoverCallToRollCellEditor,
        OptionToSellCellRenderer,
        UnderlyingTargetCellRendererComponent,
        OptionChainsDialog,
        PurchaseUnderlyingSettingsComponent,
        RollCoveredcallSettingsComponent, OptionToOpenCellRenderer,
        EditorMultipleAccountsComponent,
        ComExternalAccountsComponent,
        EditorModelComponent,
        EditorPortfolioResultComponent,
        ComPrSummaryComponent,
        ComPrCashValuesComponent,
        ComPrOrdersComponent,
        ComPrActionPanelComponent,
        ComPrInfoBannerComponent,
        SecurityAllocationsComponent,
        SecurityModelHistoryComponent,
        SecurityAllocationsChartComponent,
        LegacyAllocationsChartComponent,
        MmcAllocationsChartComponent,
        RebalanceIncludedPortfolioComponent,
        ImportExtraCashSettingsDialogComponent,
        LossPrioritySettingsDialogComponent,
        lightningIconCellComponent,
        EditorHarvestTaxLossRebalanceComponent,
        ComHarvestTaxLossRebalanceSettingComponent,
        BlendedModelsAllocationComponent,
        BlendedSecurityAllocationComponent,
        customCheckboxCellRenderer,
        EditorReplaceSecuritiesRebalanceComponent,
        ReplaceSecuritiesRebalSettingsComponent,
        AdjustSecuritiesRebalSettingsComponent,
        InvestCashRebalanceSettingsComponent,
        GenerateInvestCashRebalanceSettingsComponent,
        validationPercentCellEditorComponent,
        EditorSecurityComponent,
        SecurityAssetCategoryComponent,
        EditorMultipleSecurityComponent,
        TradingMinimumsComponent,
        ComponentSecuritiesComponent,
        BlendedSecurityAllocationGroupcellComponent,
        BlendedModelAllocationGroupcellComponent,
        SecurityPenaltybarComponent,
        ExternalShareHoldingComponent,
        RebalanceBandsComponent,
        SecurityRestrictionsComponent,
        SecurityEquivalentsAlternativesComponent,
        ComEsSecurityEquivalentsComponent,
        ComEsSecurityAlternativesComponent,
        altIfHeldCheckboxCellRenderer,
        InverseAccountTypeDialogComponent,
        ComponentSecuritiesDeleteCellComponent,
        ComponentSecuritiesDeleteAllComponent,
        EditTradingInstructionsComponent,
        ReinvestmentTradeComponent,
        TradeInstructionsComponent,
        OrderHeaderComponent,
        SelectMultiplePortfoliosDialogComponent,
        TradeDetailsComponent,
        TradeDetailsSymbolRendererComponent,
        ReplaceWithRendererEditorComponent,
        ReplaceWithRendererComponent,
        EditorBuyMultipleReplacementComponent,
        HouseholdLocationPreferencesComponent,
        ComPrActionButtonsComponent,
        EditorMmcModelComponent,
        MmcOverviewModelComponent,
        MmcSecuritiesModelComponent,
        MmcImportModelTargetComponent,
        MmcPerformanceModelComponent,
        MmcBackgroundCostModelComponent,
        ImportLossPrioritySettingsDialogComponent,
        ImportLossPrioritySettingsErrorsDialogComponent,
        MmcModelHistoryComponent,
        MmcMarketingDocumentsDialogComponent,
        EditorMmcAdvisorModelComponent,
        MmcAdvisorSecurityAllocationsComponent,
        SundryAcctAuthDialogComponent,
        PaidAgreementDialogComponent,
        MmcOverviewMarketingDocumentsComponent,
        MoveSecuritiesWarningsDialogComponent,
        MoveSecuritiesGridDataDialogComponent,
        MoveSecuritiesUsageReviewDialogComponent,
        SecurityComponentsDialogComponent,
        ModelUsedInRebalanceDialogComponent,
        ComScheduledRebalancesListComponent,
        ComAutomatedRebalancingComponent,
        ComIncludeInScheduledRebalanceDialogComponent,
        ComPrOrdersAccountGroupcellComponent,
        ComPortfolioHistoryComponent,
        TlhWashSaleAlternativesComponent,
        RebalanceTypeInfoDialogComponent,
        EditorTlhFullRebalanceComponent,
        TlhRebalanceSettingsComponent,
        ComCustomLabelsComponent,
        CustomOverviewModelComponent,
        PortfolioEquivalentsAlternativesComponent,
        ComAcLevelsComponent,
        ComPrHeaderGroupComponent,
        ComGainsComponent,
        ComPrAllocationsLegacyComponent,
        ComPrAllocationChartLegacyComponent,
        ModelAllocationChartGroupComponent,
        SecurityHistoryComponent,
        EditorQuickOrderEntryComponent
    ],
    exports: [
        EditorPortfolioComponent,
        EditorMultiplePortfoliosComponent,
        EditorSidebarComponent,
        EditorFullRebalanceComponent,
        EditorManualAdjustmentRebalanceComponent,
        EditorInvertCashComponent,
        EditorGenerateInvestCashComponent,
        EditorGenerateCashComponent,
        EditorAdjustSecuritiesRebalanceComponent,
        EditorAccountComponent,
        EditorCoveredcallRebalanceComponent,
        RebalanceSchedulerComponent,
        RebalanceGeneralInfoComponent,
        CoveredcallRebalSettingsComponent,
        SellCoveredcallSettingsComponent,
        BuyToCoverSettingsComponent, DaysToExpirationCellEditor, OptionToCloseCellEditor, OptionToCloseCellRenderer, OptionToCloseRollCellEditor, OptionToCloseRollCellRenderer,
        UnderlyingToCoverCellEditor, UnderlyingToPurchaseCellEditor, UnderlyingToTrimCellEditor, OptionToBuyBackCellEditor, CoverCallToRollCellEditor,
        OptionToSellCellRenderer,
        UnderlyingTargetCellRendererComponent,
        OptionChainsDialog,
        PurchaseUnderlyingSettingsComponent,
        RollCoveredcallSettingsComponent, OptionToOpenCellRenderer,
        EditorMultipleAccountsComponent,
        RebalanceIncludedPortfolioComponent,
        ImportExtraCashSettingsDialogComponent,
        LossPrioritySettingsDialogComponent,
        lightningIconCellComponent,
        EditorHarvestTaxLossRebalanceComponent,
        ComHarvestTaxLossRebalanceSettingComponent,
        EditorSecurityComponent,
        customCheckboxCellRenderer,
        EditorReplaceSecuritiesRebalanceComponent,
        ReplaceSecuritiesRebalSettingsComponent,
        AdjustSecuritiesRebalSettingsComponent,
        InvestCashRebalanceSettingsComponent,
        GenerateInvestCashRebalanceSettingsComponent,
        validationPercentCellEditorComponent,
        EditorMultipleSecurityComponent,
        SecurityAssetCategoryComponent,
        TradingMinimumsComponent,
        ComponentSecuritiesComponent,
        SecurityPenaltybarComponent,
        ExternalShareHoldingComponent,
        RebalanceBandsComponent,
        SecurityRestrictionsComponent,
        SecurityEquivalentsAlternativesComponent,
        ComEsSecurityEquivalentsComponent,
        ComEsSecurityAlternativesComponent,
        altIfHeldCheckboxCellRenderer,
        InverseAccountTypeDialogComponent,
        EditTradingInstructionsComponent,
        SelectMultiplePortfoliosDialogComponent,
        TradeDetailsComponent,
        TradeDetailsSymbolRendererComponent,
        HouseholdLocationPreferencesComponent,
        ImportLossPrioritySettingsDialogComponent,
        MmcModelHistoryComponent,
        MmcMarketingDocumentsDialogComponent,
        MmcOverviewMarketingDocumentsComponent,
        ComPortfolioHistoryComponent,
        ComAccountHistoryComponent,
        RebalanceTypeInfoDialogComponent
    ],
    providers: [
        IrbEditorsService,
        UtilityService,
        ValidationService,
        AppService,
        PageService
    ]
})
export class IrbEditorsModule {
    constructor(private injector: Injector) {
        ServiceLocator.injector = this.injector;
    }
}
